import { isValidLocale } from '../locale-validation'
import type {
  AllowedLocaleCountry,
  AllowedLocaleLanguage,
  Locale,
} from '../types/locale'

export const getLanguageFromLocale = (
  locale: Locale,
): AllowedLocaleLanguage => {
  if (!isValidLocale(locale)) {
    throw new Error(`Invalid locale: ${locale}`)
  }
  return locale.split('-')[0] as AllowedLocaleLanguage
}

export const getCountryFromLocale = (locale: Locale): AllowedLocaleCountry => {
  if (!isValidLocale(locale)) {
    throw new Error(`Invalid locale: ${locale}`)
  }
  return locale.split('-')[1] as AllowedLocaleCountry
}
